import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';

export class CompanyConfigState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public email: string;
  public companyConfig: any;
  public companyConfigIndex: any;
  public isContrastColor: boolean;
  public isAnonymousBrowsing: boolean;
  public siteId: string;
  public orderFromSite: string;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.companyConfig = null;
    this.isContrastColor = false;
    this.isAnonymousBrowsing = false;
    this.siteId = null;
    this.orderFromSite = null;
  }
}
